/**
 * @generated SignedSource<<a426655c04bec5d814de0a4b01b37c5e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserNotificationsMarkAllAsRead_viewer$data = {
  readonly userNotifications: {
    readonly " $fragmentSpreads": FragmentRefs<"useGetAllUnreadNotifications_userNotifications">;
  } | null;
  readonly " $fragmentType": "UserNotificationsMarkAllAsRead_viewer";
};
export type UserNotificationsMarkAllAsRead_viewer$key = {
  readonly " $data"?: UserNotificationsMarkAllAsRead_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserNotificationsMarkAllAsRead_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showPriceDropNotifications"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserNotificationsMarkAllAsRead_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "showPriceDropNotifications",
          "variableName": "showPriceDropNotifications"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "UserNotifications",
      "kind": "LinkedField",
      "name": "userNotifications",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetAllUnreadNotifications_userNotifications"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f6ce0a0f0dbcbea2983a736b75a6c150";

export default node;
